import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { trackById } from '~utilities/trackById';

@Component({
  selector: 'sa-median-selector',
  templateUrl: './median-selector.component.html',
})
export class MedianSelectorComponent implements OnInit {
  @Input() public hintText = '';
  @Input() public medians = [0.5, 0.75, 0.95];
  @Input() public default = 0.5;
  @Output() public newItemEvent = new EventEmitter<number>();
  public selectedMedian = this.medians[0];

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public readonly trackById = trackById;

  public ngOnInit(): void {
    this.selectedMedian = this.default;
  }

  public setMedian(median: number): void {
    this.kpiDashboardService.setMedian(median);
    this.newItemEvent.emit(median);
    this.selectedMedian = median;
  }
}
